import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  imports: [CommonModule],
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.scss'
})
export class ToggleSwitchComponent {
  @Input() enabled: boolean = false;
  @Output() toggled = new EventEmitter<boolean>();

  toggle(): void {
    this.enabled = !this.enabled;
    this.toggled.emit(this.enabled);
  }
}
